import script from "./HelpOptions2.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpOptions2.vue?vue&type=script&setup=true&lang=ts"

import "./HelpOptions2.vue?vue&type=style&index=0&id=0c17d301&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c17d301"]])

export default __exports__